/* Signature — product comparison. Selection persists for the session;
   the table is built only from real product data returned by Shopify. */
(function () {
  'use strict';

  const KEY = 'sig:compare';
  const MAX = 4;
  const tray = document.getElementById('compare-tray');
  const dialog = document.getElementById('compare-dialog');
  if (!tray || !dialog) return;

  const countEl = tray.querySelector('[data-compare-count]');
  const body = dialog.querySelector('[data-compare-body]');

  function read() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* ignore */
    }
    sync();
  }

  function sync() {
    const list = read();
    tray.hidden = list.length === 0;
    if (countEl) countEl.textContent = String(list.length);
    document.querySelectorAll('[data-compare-toggle]').forEach((input) => {
      const handle = input.getAttribute('data-compare-toggle');
      input.checked = list.includes(handle);
      input.disabled = !input.checked && list.length >= MAX;
    });
  }

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-compare-toggle]');
    if (!input) return;
    const handle = input.getAttribute('data-compare-toggle');
    const list = read();
    if (input.checked) {
      if (!list.includes(handle)) list.push(handle);
    } else {
      const i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1);
    }
    write(list);
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-compare-clear]')) {
      write([]);
      return;
    }
    if (e.target.closest('[data-compare-open]')) {
      render();
    }
  });

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function cell(text) {
    const td = document.createElement('td');
    td.textContent = text;
    return td;
  }

  async function render() {
    const list = read();
    if (!list.length) return;
    body.innerHTML = '<p class="text-muted">Loading…</p>';
    window.sigOpenDialog(dialog, document.querySelector('[data-compare-open]'));
    try {
      const products = await Promise.all(
        list.map((h) => fetch('/products/' + h + '.js').then((r) => (r.ok ? r.json() : null)))
      );
      const items = products.filter(Boolean);
      if (!items.length) throw new Error('none');

      const table = document.createElement('table');
      table.className = 'compare-table';

      /* header row: image + title */
      const thead = document.createElement('thead');
      const hr = document.createElement('tr');
      hr.appendChild(document.createElement('th'));
      items.forEach((p) => {
        const th = document.createElement('th');
        const a = document.createElement('a');
        a.href = '/products/' + p.handle;
        if (p.featured_image) {
          const img = document.createElement('img');
          img.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=300';
          img.alt = '';
          img.loading = 'lazy';
          img.className = 'compare-table__img';
          a.appendChild(img);
        }
        const span = document.createElement('span');
        span.textContent = p.title;
        a.appendChild(span);
        th.appendChild(a);
        hr.appendChild(th);
      });
      thead.appendChild(hr);
      table.appendChild(thead);

      const tbody = document.createElement('tbody');
      const optionCount = (p, pattern) => {
        const names = (p.options || []).map((o) => (typeof o === 'string' ? o : o && o.name));
        const idx = names.findIndex((n) => pattern.test(n || ''));
        if (idx < 0 || !p.variants) return null;
        const key = 'option' + (idx + 1);
        const values = new Set(p.variants.map((v) => v[key]).filter(Boolean));
        return values.size ? String(values.size) : null;
      };
      const priceRange = (p) => {
        if (!p.variants || !p.variants.length) return money(p.price);
        const prices = p.variants.map((v) => v.price);
        const min = Math.min.apply(null, prices);
        const max = Math.max.apply(null, prices);
        return min === max ? money(min) : money(min) + ' – ' + money(max);
      };
      const rows = [
        ['Price', priceRange],
        ['Purchase status', (p) => (p.available ? 'Available to order' : 'Currently unavailable')],
        ['Colors', (p) => optionCount(p, /color|colour/i) || '—'],
        ['Sizes', (p) => optionCount(p, /size/i) || '—'],
        ['Type', (p) => p.type || '—'],
        ['SKU', (p) => (p.variants && p.variants[0] && p.variants[0].sku) || '—'],
        ['Options', (p) => (p.variants ? String(p.variants.length) : '—')],
      ];
      rows.forEach(([label, fn]) => {
        const tr = document.createElement('tr');
        const th = document.createElement('th');
        th.scope = 'row';
        th.textContent = label;
        tr.appendChild(th);
        items.forEach((p) => tr.appendChild(cell(fn(p))));
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);

      const wrap = document.createElement('div');
      wrap.className = 'compare-scroll';
      wrap.appendChild(table);
      body.replaceChildren(wrap);
    } catch (err) {
      body.innerHTML = '<p class="text-muted">Could not load these products.</p>';
    }
  }

  sync();
})();
